<template>
  <span>
    <el-button v-if="noFiles" type="danger">Нет загруженных файлов</el-button>
    <el-button v-if="uploadFiles" type="primary" @click="showModal">
      Перейти к загрузке файлов
    </el-button>
    <el-button v-if="viewFiles" type="warning" @click="showModal">
      Просмотреть файлы
    </el-button>
    <el-dialog
      :before-close="checkForm"
      :title="formNameDocument"
      :visible.sync="isShowModal"
      :width="widthDialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      class="upload-doc-modal"
      @opened="onDialogOpened"
    >
      <el-card v-if="countAdvanceInfo > 0 && showAdvanceInfo" class="box-card">
        <el-form label-width="120px">
          <el-form-item
            v-for="(info, index) in advancedInfo"
            :key="index"
            :label="info.title"
          >
            <el-input v-model="advancedFormModel[info.fieldName]" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="subMitAdvancedForm">
              Сохранить
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <ul class="help_upload">
        <li>Выберите файлы для загрузки и нажмите загрузить файлы.</li>
        <li>Дождитесь пока загружаемые файлы появятся в списке ниже</li>
      </ul>
      <!--      <el-link-->
      <!--        v-if="countAdvanceInfo > 0"-->
      <!--        type="primary"-->
      <!--        @click="showAdvanceInfo = !showAdvanceInfo"-->
      <!--      >-->
      <!--        Показать доп информацию-->
      <!--      </el-link>-->
      <approve-file v-if="canAction('approveAuto')" @approved="setApprove" />
      <additionals-form
        v-if="needAdditional"
        :document="document"
        :document-id="document.id"
        @changed="changed"
      />
      <upload-files
        :docunent-id="documentId"
        :pasted-file="pastedFile"
        @uploaded="uploaded"
        @startUpload="onStartUpload"
        @aborted="onAborted"
      />
      <list-uploaded-files
        v-if="issetDocument"
        :file-list="fileList"
        @getZip="getZip"
        @deleteOne="deleteOne"
        @deleteAll="deleteAll"
      />
    </el-dialog>
  </span>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import AdditionalsForm from './AdditionalsForm'
import ApproveFile from './ApproveFile'
import ListUploadedFiles from './ListUploadedFiles'
import UploadFiles from './UploadFiles'

const FileRepository = RepositoryFactory.get('file')
const DocumentRepository = RepositoryFactory.get('document')

export default {
  name: 'UploadDocumentModal',
  components: { ApproveFile, AdditionalsForm, UploadFiles, ListUploadedFiles },
  props: {
    advancedInfo: {
      type: Object,
      default: () => {},
    },
    objectData: {
      type: Object,
      default: () => {},
    },
    needAdditional: {
      type: Boolean,
      default: false,
    },
    sourceId: {
      type: Number,
      default: 0,
    },
    nameDocument: {
      type: String,
      default: '',
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      advancedFormModel: {},
      showAdvanceInfo: false,
      document: '',
      isShowModal: false,
      fileExpire: '',
      isApprove: 0,
      formNameDocument: '',
      pastedFile: null,
    }
  },
  computed: {
    countAdvanceInfo() {
      return this.advancedInfo ? Object.keys(this.advancedInfo).length : 0
    },
    documentId() {
      return this.document ? this.document.id : 0
    },
    issetDocument() {
      return Boolean(this.document)
    },
    fileList() {
      return this.document ? this.document.files : []
    },
    countFiles() {
      let count = 0

      if (this.document.files) {
        count = this.document.files.length
      }

      return count
    },
    noFiles() {
      // могут добавлять файлы ?
      return !this.canUpload && (!this.document || this.countFiles === 0)
    },
    viewFiles() {
      return this.document && this.document.files && this.document.files.length
    },
    uploadFiles() {
      return (
        this.canUpload &&
        this.document &&
        this.document.files &&
        this.countFiles === 0
      )
    },
  },
  watch: {
    sourceId: {
      immediate: true,
      handler() {
        this.setDataForEdit()

        if (this.dataEdit) {
          this.formNameDocument = this.getDocumentByType(
            this.dataEdit.documentType,
          ).name
        }
        if (this.objectData) {
          this.setAdditionalDefault(this.objectData)
        }
      },
    },
  },
  methods: {
    canUpload() {
      return this.$canAction('uploadFilesAuto', this.userInfo)
    },
    setAdditionalDefault(data) {
      let aa = {}

      for (let key in this.advancedInfo) {
        aa[this.advancedInfo[key].fieldName] =
          data[this.advancedInfo[key].fieldName]
      }

      return (this.advancedFormModel = aa)
    },
    subMitAdvancedForm() {
      this.$emit('savedAdvanced', this.advancedFormModel)
    },
    deleteOne(data) {
      this.$confirm('Вы действительно хотите удалить файл' + data, 'Warning', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const fordel = this.fileList.filter(item => item.link === data)

        if (fordel) {
          this.deleteApi(fordel[0])
        }
      })
    },
    deleteAll() {
      this.$confirm('Вы действительно хотите удалить все файлы', 'Warning', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        for (let key in this.fileList) {
          this.deleteApi(this.fileList[key])
        }
      })
    },
    deleteApi(file) {
      FileRepository.dellOne(file.id).then(() => {
        this.document.files = this.document.files.filter(
          item => file.id !== item.id,
        )
        this.$emit('ready', this.document)
      }) // TODO поймать ошибку например файл подтвержден
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', 'file.zip') // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    getZip() {
      this.downloadRegistry({
        path: DocumentRepository.getZipUrl(this.document.id),
        blank: 1,
      })
    },
    changed(data) {
      DocumentRepository.update(this.document.id, data)
        .then(() => {
          this.getDocuments()
          this.$message.success('Сохранено успешно')
        })
        .catch(err => this.errHandler(err))
    },
    getApproveOneDoc(documents) {
      // если есть аппрув док то берем только его, если нет то берем первый попавшийся ибо все равно не будет правильного
      let documentItem

      for (let key in documents) {
        if (documentItem === undefined) {
          documentItem = documents[key]
        }
        if (documents[key].approve_status.length !== 0) {
          documentItem = documents[key]
        }
      }
      this.document = documentItem
      this.$emit('ready', this.document)
    },
    getDocuments() {
      // получить документ // если нету то создаем
      if (this.dataEdit.sourceId) {
        DocumentRepository.getDocument(
          this.dataEdit.sourceModelName,
          this.dataEdit.sourceId,
          this.dataEdit.documentType,
        )
          .then(response => {
            if (response.data.length) {
              this.getApproveOneDoc(response.data)
            } else if (this.$canAction('createDocAuto', this.userInfo)) {
              DocumentRepository.createDocument(
                this.dataEdit.sourceModelName,
                this.dataEdit.sourceId,
                this.getDocumentTypeIdByType(this.dataEdit.documentType),
              )
                .then(responseNewDoc => {
                  this.getDocuments()
                  this.$emit('created', responseNewDoc.data.id)
                })
                .catch(err => this.errHandler(err))
            }
          })
          .catch(err => this.errHandler(err))
      }
    },
    checkForm(done) {
      /* if (this.fileList.length > 0 && this.needAdditional) {
          if (this.additionalData.numDoc == "" || this.additionalData.numDoc === null) {
            this.$message.error("Заполните номер документа и нажмите кнопку сохранить");
            return false;
          }
      }*/
      window.removeEventListener('paste', this.handlePaste)
      done()
    },
    showModal() {
      this.isShowModal = true
    },
    uploaded(file) {
      this.fileList.unshift(file)
      this.pastedFile = null
      window.addEventListener('paste', this.handlePaste)
    },
    setApprove(data) {
      FileRepository.approveFiles(
        this.dataEdit.sourceModelId,
        this.dataEdit.sourceId,
        this.dataEdit.fileType,
        data.status,
        data.comment,
      )
        .then(() => (this.isApprove = data.status))
        .catch(err => this.errHandler(err))
    },
    setDataForEdit() {
      this.getDocuments()
    },
    onDialogOpened() {
      window.addEventListener('paste', this.handlePaste)
    },
    handlePaste(ev) {
      const items = (ev.clipboardData || ev.originalEvent.clipboardData).items

      for (let i in items) {
        let item = items[i]

        if (item.kind === 'file') {
          let blob = item.getAsFile()
          let allowedFormats = ['image/jpeg', 'image/png']
          let isSize = blob.size / 1024 / 1024 < 15

          if (!allowedFormats.includes(blob.type)) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Неверный формат',
            )
          }
          if (!isSize) {
            this.$alert(
              'Ошибка при загрузке файла ' + blob.name + '. Превышен размер',
            )
          }
          if (isSize && allowedFormats.includes(blob.type)) {
            this.pastedFile = blob
          }
        }
      }
    },
    onStartUpload() {
      window.removeEventListener('paste', this.handlePaste)
    },
    onAborted() {
      window.addEventListener('paste', this.handlePaste)
    },
  },
}
</script>

<style lang="sass">
.upload-doc-modal
  font-family: "Rubik", sans-serif
  .box-card
    z-index: 5000 !important
    position: fixed
    left: 0
    top: 0
    width: 20%
    background-color: white
  .help_upload
    padding-left: 10px !important
    color: #a5a5a5
    font-size: 15px
    font-family: "Rubik", sans-serif
  .help_upload li
    padding-top: 5px
  .el-alert--success
    font-weight: bold !important
    cursor: pointer !important
</style>
